import React, { useRef, useState } from 'react'
import cl from './CollectingScores.module.css'
import { Button, Flex, Link, useToast } from '@chakra-ui/react'
import FileUpload from '../../components/FileUpload/FileUpload'
import { CheckIcon, SmallCloseIcon } from '@chakra-ui/icons'
import ScoreService from '../../API/ScoreService'
import { useConfirmationModalStore } from '../../store/modalsStore'
import { useScoreStore } from '../../store/scoreStore'

function CollectingScoresConfirmations({data}) {
    const toast = useToast()
    const [files, setFiles] = useState(null)
    const [isLoading, setIsLoading] = useState(false)
    const storeAddFile = useScoreStore(state => state.addFile)
    const storeRemoveFile = useScoreStore(state => state.removeFile)
    const confirmationDisclosure = useConfirmationModalStore(state => state.disclosure)
    const setConfirmationModalState = useConfirmationModalStore(state => state.setState)
    const fileUploadRef = useRef(null)

    const save = () => {
        setIsLoading(true)

        const formData = new FormData()
        formData.append('email', data.email)
        formData.append('class_year', data.class_year_id)
        for (let i = 0; i < files.length; i++) {
            formData.append('files', files[i])
        }

        toast.promise(
            ScoreService.addConfirmationFiles(formData),
            {
                success: (response) => {
                    storeAddFile('confirmation', data.site_id, response.data)
                    fileUploadRef.current?.reset()
                    setFiles(null)
                    setIsLoading(false)
                    return { title: 'Файл загружен' }
                },
                error: () => {
                    setFiles(null)
                    setIsLoading(false)
                    return { title: 'Не удалось загрузить файл' }
                },
                loading: { title: 'Файл загружается...', position: 'top' },
            }
        )
    }

    const deactivateFile = (fileId) => {
        setIsLoading(true)
        toast.promise(
            ScoreService.deactivateConfirmationFile(fileId),
            {
                success: () => {
                    storeRemoveFile('confirmation', data.site_id, fileId)
                    setIsLoading(false)
                    return { title: 'Файл деактивирован' }
                },
                error: () => {
                    setIsLoading(false)
                    return { title: 'Не удалось деактивировать файл' }
                },
                loading: { title: 'Файл деактивируется...', position: 'top' },
            }
        )
    }

    return (
        <Flex className={cl.tdMultipleRow}>
            {data?.confirmations && data.confirmations.filter(c => c.is_active).map(c => (
                <Flex gap='6px' key={c.id}>
                    <Link href={c.file_url}>
                        {c.title}
                    </Link>
                    <Button
                        ml='auto'
                        size='xs'
                        variant='outline'
                        disabled={isLoading}
                        onClick={() => {
                            setConfirmationModalState({
                                title: "Деактивация файла",
                                question: `Вы действительно хотите деактивировать файл "${c.title}", подтверждающий баллы экзамена?`,
                                btnText: "Деактивировать",
                                func: deactivateFile,
                                args: [c.id]
                            })
                            confirmationDisclosure.onOpen()
                        }}
                    >
                        <SmallCloseIcon />
                    </Button>
                </Flex>
            ))}
            <Flex gap='4px'>
                <FileUpload
                    ref={fileUploadRef}
                    size='xs'
                    multiple={true}
                    accept='image/jpeg,image/png,image/gif,application/pdf,video/mp4,video/webm'
                    _onChange={e => setFiles(e.target.files.length ? e.target.files : null)}
                />
                {files &&
                <Button size='xs' disabled={isLoading} onClick={save}>
                    <CheckIcon />
                </Button>}
            </Flex>
        </Flex>
    )
}

export default CollectingScoresConfirmations
